import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDoc, doc, addDoc, collection, serverTimestamp, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig.js";
import { useAuth } from "../context/AuthContext.js"; // Asegúrate de tener el contexto de autenticación configurado
import "../components/TarjetaPersonal.css"; // Estilos personalizados
import Menu from '../components/Menu.js';
import Loading from "../components/Loading.js";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaLink,
  FaPaperPlane,
} from "react-icons/fa";

const PersonalCard = () => {
  const { uid } = useParams(); // Obtener el UID del profesional desde la URL
  const navigate = useNavigate(); // Para redirigir si no está autenticado
  const { currentUser } = useAuth(); // Obtener el usuario autenticado del contexto
  const [profesional, setProfesional] = useState(null);
  const [flip, setFlip] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [cantidadSolicitudes, setCantidadSolicitudes] = useState(0); // Estado para la cantidad de solicitudes

  useEffect(() => {
    const fetchProfesional = async () => {
      try {
        const docRef = doc(db, "users", uid); // Consultar la base de datos
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProfesional(docSnap.data());
        } else {
          console.error("No se encontró al profesional.");
        }
      } catch (error) {
        console.error("Error al obtener la información del profesional:", error);
      }
    };

    const fetchSolicitudes = async () => {
      try {
        const q = query(
          collection(db, "solicitudservicios"),
          where("asignado", "==", uid), // Filtra por el campo "asignado" igual al "uid" del usuario
          where("estado", "==", "finalizado") // Filtra por el campo "estado" igual a "finalizado"
        );
        const querySnapshot = await getDocs(q);
        setCantidadSolicitudes(querySnapshot.size); // Guarda la cantidad de documentos
      } catch (error) {
        console.error("Error al obtener las solicitudes:", error);
      }
    };
    

    fetchProfesional();
    fetchSolicitudes(); // Llamar a la función para obtener las solicitudes

  }, [uid]);

  if (!profesional) return <div><Loading /></div>;

  const { fullName, profession, description, experience, achievements, imgprof } = profesional;

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`,
    x: `https://twitter.com/intent/tweet?url=${window.location.href}`,
    whatsapp: `https://wa.me/?text=Conoce más sobre ${fullName}: ${window.location.href}`,
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Enlace copiado al portapapeles");
  };

  const handleCardClick = (e) => {
    if (!e.target.closest(".compartir-tarjeta")) {
      setFlip((prevFlip) => !prevFlip);
    }
  };
  
  const handleEnviarMensaje = async () => {
    if (!currentUser) {
      alert("Debes estar autenticado para enviar un mensaje.");
      navigate("/login"); // Redirige a la página de inicio de sesión si no está autenticado
      return;
    }

    if (mensaje.trim() === "") {
      alert("El mensaje no puede estar vacío.");
      return;
    }

    try {
      await addDoc(collection(db, "mensajes"), {
        emisor: {
          uid: currentUser.uid,
          nombre: currentUser.displayName || "Usuario sin nombre",
        },
        receptor: {
          uid: uid,
          nombre: fullName,
        },
        mensaje: mensaje,
        fechaHora: serverTimestamp(),
      });

      setMensaje(""); // Limpiar el campo de entrada
      alert("Mensaje enviado con éxito.");
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      alert("Ocurrió un error al enviar el mensaje. Por favor, inténtalo de nuevo.");
    }
  };

  const imgProfUrl = imgprof?.fileURL;
  const imgProfName = imgprof?.fileName;

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div
          className="tarjeta-personal"
          onClick={handleCardClick}
          onTouchStart={handleCardClick}
        >
          <div className={`flip-container ${flip ? "flipped" : ""}`}>
            <div className="card">
              <div className="front">
                <div className="contenido">
                  <h2 className="nombreProf">{fullName}  {profesional.promedioPuntuacion && (
                    <p>
                      {' '}
                      {parseFloat(profesional.promedioPuntuacion).toFixed(2)}{' '}
                      <i className="fas fa-star" style={{ color: 'gold' }}></i>
                    </p>
                  )}</h2>
                  <p className="profession">{profession}</p>
                  <p className="description">{description}</p>

                  {/* Muestra la cantidad de solicitudes debajo de la descripción */}
                  <p className="cantidad-solicitudes">
                    Servicios finalizados: {cantidadSolicitudes}
                  </p>

                  <div className="experiencia-logros">
                    <h4>Experiencia</h4>
                    <p>{experience || "No especificado"}</p>
                    <h4>Logros</h4>
                    <ul>
                      {achievements?.length > 0
                        ? achievements.map((achievement, index) => (
                            <li key={index}>{achievement}</li>
                          ))
                        : "Sin logros destacados"}
                    </ul>
                  </div>

                  {/* Sección para compartir */}
                  <div className="compartir-tarjeta">
                    <h3 className="compartir-titulo">Compartir esta tarjeta</h3>
                    <div className="iconos-refs-c">
                      <ul className="wrapper-icons sci">
                        <li className="icon comentarios">
                          <a
                            href={shareLinks.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>
                              <FaFacebook />
                            </span>
                          </a>
                        </li>
                        <li className="icon comentarios">
                          <a
                            href={shareLinks.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>
                              <FaLinkedin />
                            </span>
                          </a>
                        </li>
                        <li className="icon comentarios">
                          <a
                            href={shareLinks.x}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>
                            <i className="fa-brands fa-x-twitter"></i>
                            </span>
                          </a>
                        </li>
                        <li className="icon comentarios">
                          <a
                            href={shareLinks.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>
                              <FaWhatsapp />
                            </span>
                          </a>
                        </li>
                        <li className="icon comentarios">
                          <a href="#" onClick={handleCopyLink}>
                            <span>
                              <FaLink />
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="back">
                <div className="portada">
                  {imgProfUrl ? (
                    imgProfName.endsWith(".mp4") || imgProfName.endsWith(".webm") ? (
                      <video controls className="imgProf">
                        <source src={imgProfUrl} type="video/mp4" />
                        Tu navegador no soporta el formato de video.
                      </video>
                    ) : (
                      <img
                        src={imgProfUrl}
                        className="imgProf"
                        alt="Imagen del profesional"
                      />
                    )
                  ) : (
                    <p>No hay imagen o video disponible</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Input para enviar mensaje */}
        <div className="enviar-mensaje d-flex align-items-center">
          <input
            type="text"
            className="form-control me-2" // Espaciado entre el input y el botón
            placeholder="Escribe tu mensaje..."
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
          />
          <button className="btn btn-primary" onClick={handleEnviarMensaje}>
            <FaPaperPlane />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalCard;
